import { BaseModel } from "@/models/base.model"
import { type IBase } from "@/interfaces/api/base.interface"
import { BaseRepository } from "@/repositories/base-repository"
import { type IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export abstract class BaseAPIFunctions<
  Model extends BaseModel,
  IData extends IBase,
  Repository extends BaseRepository<IData>
> {
  protected repository: Repository

  protected constructor(repository: Repository) {
    this.repository = repository
  }

  public getRepository(): Repository {
    return this.repository
  }

  public abstract getModel(
    id: string,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<IData | null>

  public abstract getModels(requestConfig?: IRepositoryRequestConfig): Promise<IData[]>

  public abstract createModel(data: IData, requestConfig?: IRepositoryRequestConfig): Promise<IData>
  public abstract createModel(
    data: IData[],
    requestConfig?: IRepositoryRequestConfig
  ): Promise<IData[]>

  public abstract updateModel(data: IData, requestConfig?: IRepositoryRequestConfig): Promise<IData>
  public abstract updateModel(
    data: IData[],
    requestConfig?: IRepositoryRequestConfig
  ): Promise<IData[]>

  public abstract deleteModel(
    model: Model,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<boolean>
  public abstract deleteModel(
    model: Model[],
    requestConfig?: IRepositoryRequestConfig
  ): Promise<boolean>
}
